module.exports = __webpack_public_path__ + "asset/board-minutes-pdf--4d180e.png";